// Thông số theo dịp: mật độ hạt nền, nhịp pháo hoa. Màu nằm ở styles/season.css.
import type { SeasonKey } from '@shoptrack/common/season'

export interface SeasonInfo {
  /** Số hạt nền trên một màn 390×820 (nhân theo diện tích, tối đa ×2.4). */
  particles: number
  /** Pháo hoa nền: trung bình mỗi bao nhiêu giây một quả (0 = không). */
  fireworks: number
}

export const SEASONS: Record<SeasonKey, SeasonInfo> = {
  tet: {
    particles: 24,
    fireworks: 0,
  },
  valentine: {
    particles: 22,
    fireworks: 0,
  },
  thongnhat: {
    particles: 16,
    fireworks: 2.8,
  },
  he: {
    particles: 18,
    fireworks: 0,
  },
  thu: {
    particles: 24,
    fireworks: 0,
  },
  halloween: {
    particles: 14,
    fireworks: 0,
  },
  noel: {
    particles: 88,
    fireworks: 0,
  },
}
